import { useState } from 'react';
import './Voucher.css';
import { Link, useNavigate } from 'react-router-dom';
import { LoyaltyCards } from '../data/vouchersData';

export default function LoyaltyProgram() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupVoucher, setPopupVoucher] = useState(null);
  const [errors, setErrors] = useState({});


  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    numberPlate: '',
    numberCode: '',
  });

  const handleBuyNow = (voucher) => {
    setPopupVoucher(voucher);
    setShowPopup(true);
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      numberPlate: '',
      numberCode: '',
    });
  };

  const handleLearnMore = () => {
    navigate('/loyalty-booklet-card'); // redirect to Splash & Save Loyalty Card
  };
    const handleLearnMore1 = () => {
    navigate('/loyalty-booklet'); // redirect to Loyalty Booklet
  };

  // 🔹 Strict input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === 'phone') {
      // Only numbers, max 8
      newValue = newValue.replace(/\D/g, '').slice(0, 8);
    } else if (name === 'numberPlate') {
      // Only numbers, max 6
      newValue = newValue.replace(/\D/g, '').slice(0, 6);
    } else if (name === 'numberCode') {
      // Only letters, max 3
      newValue = newValue.replace(/[^A-Za-z]/g, '').slice(0, 3);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!/^\d{8}$/.test(formData.phone)) {
    newErrors.phone = 'Phone number must be exactly 8 digits';
  }
  if (formData.numberPlate && !/^\d{6}$/.test(formData.numberPlate)) {
    newErrors.numberPlate = 'Number plate must be exactly 6 digits';
  }
  if (formData.numberCode && !/^[A-Za-z]{3}$/.test(formData.numberCode)) {
    newErrors.numberCode = 'Number code must be exactly 3 letters (A–Z only)';
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  alert(
    `Voucher: ${popupVoucher.title}\n` +
    `First Name: ${formData.firstName}\n` +
    `Last Name: ${formData.lastName}\n` +
    `Phone: ${formData.phone}\n` +
    `Email: ${formData.email}\n` +
    `Number Plate: ${formData.numberPlate || 'Not provided'}\n` +
    `Number Code: ${formData.numberCode || 'Not provided'}`
  );

  setShowPopup(false);
};

  return (
    <>
      <div className="voucher-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Our Loyalty Program</h5>
            <h2>Book & Save on Eco-Friendly Car Care</h2>
            <p>
              Purchase or retrieve your eco-friendly car wash vouchers for great
              savings and a cleaner planet. Quick, easy, and account-free!
            </p>
          </div>
        </div>
      </div>

      <div className="voucher-page">
        <div className="breadcrumb">
          <Link to="/">Home</Link> / Loyalty Program
        </div>
        <h2 className="voucher-title">Loyalty Program</h2>

        {/* Loyalty cards list */}
        <div className="voucher-list">
          {LoyaltyCards.map((voucher) => (
            <div className="voucher-card" key={voucher.id}>
              <h3>{voucher.title}</h3>
              <p>{voucher.washes}</p>
              <div className="voucher-actions-col">
                {voucher.buttonText.includes('Learn') ? (
                  <button
                    className="voucher-btn"
                    onClick={handleLearnMore1}
                  >
                    {voucher.buttonText}
                  </button>
                ) : (
                  <button 
                    className="voucher-btn" 
                    onClick={handleLearnMore}
                  >
                    {voucher.buttonText}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Popup */}
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-form">
              <h3>Enter Your Details</h3>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone*"
                  value={formData.phone}
                  onChange={handleChange}
                  maxLength={8}
                  required
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}

                <input
                  type="email"
                  name="email"
                  placeholder="Email (Preferred)"
                  value={formData.email}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="numberPlate"
                  placeholder="Plate Number (Optional)"
                  value={formData.numberPlate}
                  onChange={handleChange}
                  maxLength={6}
                />
                {errors.numberPlate && <p className="error-text">{errors.numberPlate}</p>}

                <input
                  type="text"
                  name="numberCode"
                  placeholder="Plate Code (Optional)"
                  value={formData.numberCode}
                  onChange={handleChange}
                  maxLength={3}
                />
                {errors.numberCode && <p className="error-text">{errors.numberCode}</p>}


                <button type="submit" className="voucher-btn">
                  {popupVoucher?.buttonText || 'Get Now!'}
                </button>
              </form>

              <button
                onClick={() => setShowPopup(false)}
                style={{ background: 'none', border: 'none', color: '#888' }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}